export const PROCESS_BLOCK_NAME_MAX_LENGTH = 100;
export const PROCESS_BLOCK_DESCRIPTION_MAX_LENGTH = 300;